import * as qs from 'query-string'

export default {
  data() {
    return {
      loading: true
    }
  },
  methods: {
  },
  mounted() {
    window.localStorage.removeItem('order') // Remove existing order item
    let urlData = qs.parseUrl(window.location.href)
    let order = urlData.query['x.order.data']
    window.localStorage.setItem('order', order);
    this.$router.push({ path: 'checkout' })
  },
  props: []
}



// WEBPACK FOOTER //
// ./src/components/Payments/Payments.js